import React from "react";
import MainPageWrapper from "@/components/MainPageWrapper/MainPageWrapper";
import DataTable from "@/components/Datatable/Datatable";
import { useOrderListPage } from "../../hooks/useOrderListPage";
import { useOrderColumns } from "../../hooks/useOrderColumns";
import { useOrderStatusTransition } from "../../hooks/useOrderStatusTransition";
import OrderListFilters from "../OrderListFilters/OrderListFilters";
import UpdateOrderStatusConfirmation from "../OrderStatusProgress/UpdateOrderStatusConfirmation";
import OrderLineItemsExpandedRow from "./OrderLineItemsExpandedRow";
import { ProductStoreOrderListItem } from "../../api/fetchProductStoreOrders/types";

const OrderList: React.FC = () => {
  const {
    orders,
    totalCount,
    loading,
    error,
    pagination,
    sorting,
    filters,
    handlePaginationChange,
    handleSortingChange,
    handleFiltersChange,
  } = useOrderListPage();
  const {
    pending,
    updating,
    requestStatusUpdate,
    confirmStatusUpdate,
    cancelStatusUpdate,
  } = useOrderStatusTransition();
  const columns = useOrderColumns({ onAdvanceStatus: requestStatusUpdate });

  return (
    <MainPageWrapper
      error={error}
      subtitle="Manage and track customer orders"
      title="Orders"
    >
      <OrderListFilters
        filters={filters}
        onFiltersChange={handleFiltersChange}
      />
      <div className="relative">
        <DataTable<ProductStoreOrderListItem>
          columns={columns}
          data={orders}
          error={error}
          expandable
          loading={loading}
          noDataMessage="No orders found"
          onPageChange={(pageIndex, pageSize) =>
            handlePaginationChange({ pageIndex, pageSize })
          }
          onSortingChange={handleSortingChange}
          pageIndex={pagination.pageIndex}
          pageSize={pagination.pageSize}
          renderExpandedRow={(order) => (
            <OrderLineItemsExpandedRow order={order} />
          )}
          rowKeyExtractor={(item) => item.uuid}
          sorting={sorting}
          totalCount={totalCount}
        />
      </div>

      <UpdateOrderStatusConfirmation
        confirmationNumber={pending?.order.confirmationNumber ?? ""}
        isOpen={pending !== null}
        loading={updating}
        onCancel={cancelStatusUpdate}
        onConfirm={confirmStatusUpdate}
        targetStatus={pending?.target ?? null}
      />
    </MainPageWrapper>
  );
};

export default OrderList;
